<script>
import Lottie from 'vue-lottie';
import * as animationData from '@assets/animations/lottie/check_animation.json';

export default {
  name: 'CheckWidget',
  components: {
    Lottie,
  },
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
       defaultOptions: {
        animationData: animationData.default
      },
      animationSpeed: 1,
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
    },
  },
}

</script>
<template>
  <div :class="$style.container">
    <lottie
      :options="defaultOptions"
      :height="150"
      :width="150"
      @animCreated="handleAnimation"
    />
  </div>
</template>

<style lang="scss" scoped module>
@import '@design';

.container {
  display: flex;
  justify-content: center;
  padding: 1rem;
}

</style>
